import {Dropdown, Tooltip} from 'antd';
import styles from '../ToolBar/index.module.scss';
import {ColumnHeightOutlined} from '@ant-design/icons';
import React from 'react';
import {SizeType} from 'antd/es/config-provider/SizeContext';

interface SelectableMenuProps {
    size: SizeType;
    onChange: (size: SizeType) => void;
}

export default function SelectableMenu({size, onChange}: SelectableMenuProps) {
    return (
        <Dropdown
            menu={{
                style: {width: 80},
                selectedKeys: [size as string],
                onClick: e => onChange(e.key as SizeType),
                items: [
                    {key: 'large', label: '默认'},
                    {key: 'middle', label: '中等'},
                    {key: 'small', label: '紧凑'},
                ],
            }}
            trigger={['click']}>
            <Tooltip title="密度">
                <div className={styles.btn}>
                    <ColumnHeightOutlined />
                </div>
            </Tooltip>
        </Dropdown>
    );
}
